import { Component, Input, Output, EventEmitter, OnInit, Optional, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialog } from '../dialogs/delete-dialog.component';
import { EditEvent, SiteBuilderActions } from '../constants/edit.constants';
import { EDIT_LIBRARY_OPTIONS } from '../tokens/edit-library-options.token';
import { EditLibraryOptions, ComponentActions } from '../models/edit-library-options.model';
import { fromEvent } from 'rxjs';

@Component({
    selector: 'edit-component',
    template: `<div class="row no-padding no-margin ed-Component_Overlay" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"
  dnd-draggable [dragEnabled]="true" [dropZones]="['componentDropZone']" [dragData]="eventData"
  (onDragStart)="showDropZones()" (onDragEnd)="hideDropZones()">
  <div class="col-xs-12" *ngIf="shouldDisplay">
    <div class="ed-Component_Menu">
      <a *ngIf="allowedActions.indexOf('EDIT') > -1" href="javascript:void(0)" class="menu-item" [ngClass]="{'disabled': isEditDisabled}" 
          (click)="openEditComponent()" 
          [matTooltip]="isEditDisabled ? 'This component is not editable' : 'Edit Component'">
        <i class="fal fa-pencil-alt fa-lg"></i>
      </a>
      <a *ngIf="allowedActions.indexOf('REMOVE') > -1" href="javascript:void(0)" class="menu-item" (click)="removeComponent()" matTooltip="Remove Component">
        <i class="fal fa-times fa-lg"></i>
      </a>
    </div>
  </div>
</div>`
})
export class EditComponentComponent implements OnInit {
    shouldDisplay: boolean = false;
    allowedActions = [];
    eventData: any = {};
    isEditDisabled: boolean = false;
    @Input() componentTag: string;
    @Input() location: string;
    @Input() componentId: string;
    @Input() pageId: string;
    @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();
    constructor(
      public dialog: MatDialog,
      @Optional() @Inject(EDIT_LIBRARY_OPTIONS) private editLibraryOptions: EditLibraryOptions ) {
        this.setEditActions();
        fromEvent(window, SiteBuilderActions.UPDATE_EDIT_ACTIONS)
        .subscribe((evt: any) => {
          // if this component is in the list of non-editable components, disable edit action.
          if (evt && evt.detail && evt.detail.nonEditableComponents !== undefined) {
            let nonEditableComponents: string[] = evt.detail.nonEditableComponents;
            this.isEditDisabled = nonEditableComponents.indexOf(this.componentId) >= 0;
          }
        });
      }
    ngOnInit() {
      this.eventData = {
        componentTag: this.componentTag,
        location: this.location
      };
    }
    mouseEnter() {
        this.shouldDisplay = true;
    }
    mouseLeave() {
        setTimeout(() => {
            this.shouldDisplay = false;
        }, 50);
    }
    showDropZones() {
      let data = {
        action: SiteBuilderActions.EDIT_STYLE,
        key: 'ed-AddComponent_Overlay.border',
        value: '2px dashed #d6d6d6',
        text: '.ed-AddComponent_Overlay { border: 2px dashed #d6d6d6; }',
        skipSass: true
      };
      window.postMessage(data, '*');
    }
    hideDropZones() {
      let data = {
        action: SiteBuilderActions.REMOVE_STYLE,
        key: `ed-AddComponent_Overlay.border`
      };
      window.postMessage(data, '*');
    }
    setEditActions() {
      if (this.editLibraryOptions.allowedComponentActions !== undefined) {
        this.allowedActions = this.editLibraryOptions.allowedComponentActions;
      } else {
        // Default should allow all actions
        this.allowedActions.push(ComponentActions.EDIT);
        this.allowedActions.push(ComponentActions.REMOVE);
      }
    }
    removeComponent() {
      let dialogRef = this.dialog.open(DeleteDialog, {
        data: {
          dialogText: 'Are you sure you want to remove this component from this page?',
          buttonText: 'Remove',
          cancelText: 'Cancel'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if ( result.confirm === true ) {
          let data = {
            componentSelector: `${this.componentTag}`,
            previousLocation: `${this.location}`,
            newLocation: '',
            component: null,
            pageId: this.pageId
          };
          // window.parent.postMessage(data, '*');
          window.dispatchEvent(new CustomEvent(EditEvent.REMOVE_COMPONENT, {
              detail: { data }
          }));
          this.onUpdate.emit(result);
        }
      });
    }
    openEditComponent() {
      if (!this.isEditDisabled) {
        let data = {
          action: 'pershing.assembly.edit.EditComponent',
          componentId: this.componentId,
          componentRef: document.getElementById(this.componentId),
          componentCSS: window.getComputedStyle(document.getElementById('id' + this.componentId))
        };
        document.dispatchEvent(new CustomEvent(EditEvent.EDIT_COMPONENT, {
            detail: { data }
        }));
        window.parent.postMessage( JSON.parse(JSON.stringify(data)), '*');
      }
    }
}
